import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

let format = localStorage.getItem('format', format);
if (!format)
    format = 'hex';

export default new Vuex.Store({
    state: {
        isLoading: false,
        format,
        isDDROpen: false
    },
    mutations: {
        openDDR(state) {
            state.isDDROpen = true;
        },
        closeDDR(state) {
            state.isDDROpen = false;
        },
        toggleLoading(state) {
            state.isLoading = !state.isLoading;
            setTimeout(() => {
                state.isLoading = !state.isLoading;
            }, 2000);
        },
        setFormat(state, format) {
            state.format = format;
            localStorage.setItem('format', format);
        }
    },
    actions: {}
});



// WEBPACK FOOTER //
// ./src/store/store.js